module.exports = __webpack_public_path__ + "static/img/I.71ea3e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/I.png
// module id = jSsa
// module chunks = 0